var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authorized && _vm.configured)?_c(_vm.tag,{tag:"compntent",attrs:{"type":"button"},on:{"click":_vm.openDialog}},[_vm._t("default",function(){return [_vm._v("Google Drive")]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }